import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visible: false,
  notification: {},
};

const notificationPushSlice = createSlice({
  name: 'notificationPush',
  initialState,
  reducers: {
    showNotificationPush(state, action) {
      state.visible = true;
      state.notification = action.payload ?? {};
    },
    hideNotificationPush(state) {
      state.visible = false;
      state.notification = {};
    },
  },
});

export const { showNotificationPush, hideNotificationPush } = notificationPushSlice.actions;

export default notificationPushSlice.reducer;
